import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdicionaisEDescontosInserirComponent } from './adicionais-e-descontos-inserir.component';

const routes: Routes = [
  {path:'', component: AdicionaisEDescontosInserirComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdicionaisEDescontosInserirRoutingModule { }
